import Select from '@app/src/components/Form/Select/ControlledSelect'
import React, { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { useIntl } from 'react-intl'
import { PROGRESS_TRACKER_QUESTION_KEYS } from './CreateProgressTrackerModal'

const PeriodOffsetField = () => {
  const { formatMessage } = useIntl()
  const { control, errors } = useFormContext()

  const currentYear = new Date().getFullYear()

  const progressTrackingPeriodOffsetOptions = useMemo(
    () => [
      {
        value: 0,
        label: formatMessage(
          { id: 'schemas.progressTracker.createNewModal.periodOffsetOptions.currentYear' },
          { currentYear },
        ),
      },
      {
        value: -1,
        label: formatMessage(
          { id: 'schemas.progressTracker.createNewModal.periodOffsetOptions.currentYearMinusOne' },
          { currentYearMinusOne: currentYear - 1, currentYear },
        ),
      },
      {
        value: -2,
        label: formatMessage(
          { id: 'schemas.progressTracker.createNewModal.periodOffsetOptions.currentYearMinusTwo' },
          { currentYearMinusTwo: currentYear - 2, currentYear },
        ),
      },
    ],
    [formatMessage],
  )
  return (
    <Select<number>
      fullWidth
      hoveringLabel
      name={PROGRESS_TRACKER_QUESTION_KEYS.TRACKING_PERIOD_OFFSET}
      options={progressTrackingPeriodOffsetOptions}
      error={errors?.trackingPeriodOffset?.message}
      fieldLabel={formatMessage({ id: 'schemas.progressTracker.createNewModal.relevantPeriods' })}
      control={control}
    />
  )
}

export default PeriodOffsetField
